import * as Actions from '../actions'
import {
  lensPath,
  view,
  set,
  over,
  append,
  lensProp,
  prop,
  compose,
} from 'ramda'
import * as R from 'ramda'
import {
  AccessType,
  getPermissionInfoByPlace,
  userPlaceByIndex,
  defaultSelectedPlaceIndex,
  userPlaceBySelectedPlace,
} from 'app/auth/accessControlService'
import Assets from 'app/configs/assetConfigs'
import { getDisplayName, getUserAvatar } from './user.query'

const initialState = {
  permissionInfo: { permissions: [AccessType.ANNONYMOUS], groups: [] },
  data: {
    displayName: '',
    photoURL: Assets.personSilhouetteImage,
    email: undefined,
    shortcuts: [],
    defaultLanguage: [],
  },
}

const tokenPaths = ['auth', 'user', 'token']

const tokenLens = lensPath(tokenPaths)
export const viewToken = view(tokenLens)
export const viewTokenAccess = view(lensPath(append('accessToken', tokenPaths)))

const maModeKeyPaths = ['auth', 'user', 'maModeKey']
const maLens = lensPath(maModeKeyPaths)
export const viewMaKey = view(maLens)

const user = function (state = initialState, action) {
  switch (action.type) {
    case Actions.SET_USER_DATA: {
      const selectedPlaceIndex = R.compose(
        R.defaultTo(defaultSelectedPlaceIndex),
        R.prop('selectedPlaceIndex'),
      )(state)
      const selectedPlace = userPlaceByIndex(
        selectedPlaceIndex,
        R.path(['payload', 'data'], action),
      )
      return {
        ...initialState,
        ...action.payload,
        selectedPlace,
        permissionInfo: getPermissionInfoByPlace(selectedPlace),
      }
    }
    case Actions.REMOVE_USER_DATA: {
      return {
        ...initialState,
      }
    }
    case Actions.USER_LOGGED_OUT: {
      return initialState
    }
    case Actions.SET_USER_TOKEN: {
      return set(lensPath(['token']), action.token, state)
    }
    case Actions.UPDATE_USER_ACCESS_TOKEN: {
      return over(lensPath(['token']), R.mergeLeft(action.token), state)
    }
    case Actions.UPDATE_USER_ROLES: {
      const selectedPlaceIndex = R.compose(
        R.defaultTo(defaultSelectedPlaceIndex),
        R.prop('selectedPlaceIndex'),
      )(state)
      const selectedPlace = userPlaceByIndex(
        selectedPlaceIndex,
        R.path(['payload'], action),
      )
      return R.compose(
        set(
          lensProp('permissionInfo'),
          R.compose(getPermissionInfoByPlace, userPlaceBySelectedPlace)(
            state.selectedPlace,
            R.prop('payload', action),
          ),
        ),
        set(lensProp('selectedPlace'), selectedPlace),
      )(state)
    }
    case Actions.UPDATE_USER_DATA: {
      const newUserData = {
        ...action.payload,
        displayName: compose(getDisplayName, prop('payload'))(action),
        photoURL: compose(getUserAvatar, prop('payload'))(action),
      }
      const selectedPlaceIndex = R.compose(
        R.defaultTo(defaultSelectedPlaceIndex),
        R.prop('selectedPlaceIndex'),
      )(state)
      const selectedPlace = userPlaceByIndex(
        selectedPlaceIndex,
        R.path(['payload'], action),
      )

      return compose(
        set(lensProp('data'), newUserData),
        set(lensProp('selectedPlace'), selectedPlace),
      )(state)
    }
    default: {
      return state
    }
  }
}

export default user
